const STORAGE_KEY = 'attribution'
const LANDING_STORAGE_KEY = 'landingCampaign'
const ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
]
const LANDING_UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']
// Matches Google's 90-day gclid cookie and offline conversion import window.
const ATTRIBUTION_TTL_MS = 90 * 24 * 60 * 60 * 1000

// Last-touch Attribution: the most recent landing carrying any utm_* or Google Ads click id replaces the stored one.
export function useAttribution() {
    // Called once on page load with the landing URL's search string.
    function remember(search) {
        const params = new URLSearchParams(search)
        rememberLanding(params)
        const attribution = Object.fromEntries(
            ATTRIBUTION_KEYS.filter((key) => params.has(key)).map((key) => [key, params.get(key)])
        )
        if (!Object.keys(attribution).length) return
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ params: attribution, savedAt: Date.now() }))
    }

    function rememberLanding(params) {
        if (!params.get('utm_campaign')) return
        const utm = Object.fromEntries(
            LANDING_UTM_KEYS.filter((key) => params.has(key)).map((key) => [key, params.get(key)])
        )
        sessionStorage.setItem(LANDING_STORAGE_KEY, JSON.stringify(utm))
    }

    function peek() {
        try {
            const { params, savedAt } = JSON.parse(localStorage.getItem(STORAGE_KEY)) ?? {}
            if (!params || typeof savedAt !== 'number' || Date.now() - savedAt > ATTRIBUTION_TTL_MS) return {}
            return params
        } catch {
            return {}
        }
    }

    // PostHog keeps utm_* on every event for the rest of the tab session; this credits a tagged link
    // (e.g. a notification email) only to the first event in that tab that asks for it, as `landing_utm_*`.
    function take() {
        const stored = sessionStorage.getItem(LANDING_STORAGE_KEY)
        sessionStorage.removeItem(LANDING_STORAGE_KEY)
        if (!stored) return {}
        try {
            return Object.fromEntries(
                Object.entries(JSON.parse(stored)).map(([key, value]) => [`landing_${key}`, value])
            )
        } catch {
            return {}
        }
    }

    return { remember, peek, take }
}
